module.exports = __webpack_public_path__ + "static/media/hero-bg@3x.350d63f7.png";